import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { PageNotFound } from './features/404'
import ForgotPasswordPage from './features/auth/forgot-password'
import LoginPage from './features/auth/login'
import ResetPasswordPage from './features/auth/reset-password'
import { DashboardPage } from './features/dashboard'
import NoneProtectedRoute from './route/NoneProtectedRoute'
import ProtectedRoute from './route/ProtectedRoute'

import 'react-day-picker/style.css'
import 'react-loading-skeleton/dist/skeleton.css'
import ErrorBoundary from './components/errorBoundary/errorBoundary'
import CreatePasswordPage from './features/auth/create-password'
import { SingleSettlementPage } from './features/dashboard/singleSettlementPage'

const App = () => {
  return (
    <Router>
      <ErrorBoundary>
        <Routes>
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<DashboardPage />} />

            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/dashboard/:id" element={<SingleSettlementPage />} />

            <Route path="*" element={<PageNotFound />} />
          </Route>

          <Route element={<NoneProtectedRoute />}>
            <Route path="/auth/login" element={<LoginPage />} />
            <Route
              path="/auth/forgot-password"
              element={<ForgotPasswordPage />}
            />
            <Route
              path="/auth/reset-password"
              element={<ResetPasswordPage />}
            />

            <Route
              path="/stakeholders/setup"
              element={<CreatePasswordPage />}
            />
          </Route>

          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </ErrorBoundary>
    </Router>
  )
}

export default App
